import { LoadingUI, createLoaderInstances } from "./loadingUI";

class Loading {
  public constructor(public ui: LoadingUI) {
    this.ui.animate();
  }
}

export function initLoading() {
  return createLoaderInstances().map((ui) => {
    new Loading(ui);
  });
}
